import React from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import ReviewsCarousel from './Reviews';

const DoctorProfile = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row", // Column for mobile, row for desktop
        alignItems: "center",
        justifyContent: "left",
        background: "linear-gradient(135deg, white 30%, #1B263B 100%)",
        color: "black",
        padding: isMobile ? "30px 20px" : "50px",
        gap: isMobile ? "20px" : "40px",
        textAlign: isMobile ? "center" : "left",
      }}
    >
      {/* Doctor Image */}
      <Box
        component="img"
        src="/assets/images/tarun_reddy.jpeg" // Replace with actual image path
        alt="Dr. Tarun Reddy"
        sx={{
          width: isMobile ? "80%" : "250px", // Smaller on mobile
          height: "auto",
          borderRadius: "15px",
          boxShadow: "0px 4px 10px rgba(255, 255, 255, 0.2)",
        }}
      />

      {/* Doctor Details */}
      <Box sx={{ maxWidth: "600px", width: isMobile ? "100%" : "auto" ,color: "black" }}>
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" >
          Dr. Tarun Reddy
        </Typography>
        <Typography variant="h6" sx={{  }}>
        Consultant Surgical Oncologist <br/>
        Renova Cancer Hospital, Warangal


        </Typography>

        {/* Qualifications */}
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" mt={2}>
          Qualifications
        </Typography>
        <Typography variant="body1">
        MBBS, MS (General Surgery), MCh (Surgical Oncology)<br/>
          Department of Surgical Oncology
        </Typography>

        {/* Experience */}
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" mt={2}>
          Special Interests
        </Typography>
        <Typography variant="body1">
● Laparoscopic (keyhole) cancer surgeries </Typography>
<Typography variant="body1"> ● Robotic-assisted oncologic procedures </Typography>
● Organ-preserving and function-sparing cancer surgery

        {/* Call Now Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#28A745",
            color: "white",
            mt: 3,
            px: isMobile ? 3 : 4,
            py: isMobile ? 1 : 1.5,
            borderRadius: "50px",
            fontSize: isMobile ? "16px" : "18px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "center",
            "&:hover": { backgroundColor: "#0279c6" },
          }}
          startIcon={<CallIcon />}
        >
          Call Now
        </Button>
      </Box>

    </Box>
  );
};

export default DoctorProfile;
